import { createFileRoute } from '@tanstack/react-router';
import { Text } from '@fluentui/react-components';
import { makeStyles, tokens } from '@fluentui/react-components';
import { ReferralForm } from '@/components/referral/ReferralForm';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  heading: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  subheading: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    padding: tokens.spacingVerticalXL,
    boxShadow: tokens.shadow4,
  },
});

export const Route = createFileRoute('/referrals/new')({
  component: NewReferralPage,
});

function NewReferralPage() {
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <div>
        <Text className={styles.heading} block>
          Submit a Referral
        </Text>
        <Text className={styles.subheading} block>
          Refer a client or prospect to another ATA service line. Our team will follow up promptly.
        </Text>
      </div>

      <div className={styles.card}>
        <ReferralForm />
      </div>
    </div>
  );
}
